<template>
  <div class="App">
    <full></full>
    <toTop></toTop>
    <div class="root">
      <headerList :nav-data="navData"></headerList>
    </div>
    <RouterView></RouterView>
    <bottom></bottom>
  </div>
</template>

<script>
import { RouterView } from 'vue-router';
import full from '@/components/full.vue';
import toTop from '@/components/toTop.vue';
import headerList from '@/components/header.vue';
import axios from 'axios';
import bottom from '@/components/bottom.vue';
export default {
  name:'app',
  data() {
    return {
      navData: []
    }
  },
  components:{
    full,
    toTop,
    headerList,
    bottom
  },
  created() {
    axios.get('/api/nav/nav?page=1&page_size=9').then(res => {
      this.navData = res.data.data
      console.log(res.data.data)
      this.$store.commit('navData', res.data.data);
    })
  },
  mounted() {
        document.title = '仙桃市创源计算机科技中等职业学校';
    }
}
</script>

<style>
@media screen and (max-width:430px) {
	.media-list-ul{
		padding-top: 70px;
	}
	.header-bottom .logo img{
		width: 200px;
		height: 70px;
	}
	.container .index .banner{
		height: 270px;
	}
	.container .index .banner .search{
		top: -2rem;
	}
	.index-span{
		bottom: 1.8rem;
	}
	.banner .el-carousel__indicators--horizontal{
		display: none;
	}
	.container .index .banner .search input{
		font-size: 14px;
	}
	.news .amplify-div,.index .da-div{
		height: 260px;
	}
	.news .list ul li a, .news .top a{
		font-size: 15px;
	}
	.news .news-center{
		min-height: 520px;
	}
	.news .news-center p{
		text-indent: 0em;
		font-size: 13px;
	}
	.news .news-center a{
		font-size: 20px;
	}
	#top{
		display: none!important;
	}
	.index .img-list ul li{
		height: 260px;
		margin-bottom: 20px;
	}
	.activity .title h2{
		font-size: 23px;
	}
	.activity .activity-swiper .name2 a{
		height: 1.9rem;
		font-size: 14px;
	}
	.activity .activity-swiper .info em{
		width: 16px;
		margin-right: 5px;
	}
	.search-img{
		top: 20px;
		right: 40px;
	}
	.list-li{
		line-height: 34px;
	}
	.search-div{
		top: 59%;
		z-index: 21;
		width: 90.1%;
		left: 4.89%;
	}
  .media-list-ul{
    padding-top: 60px;
  }
}
</style>